import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * 스피너 + 점이 하나씩 늘어나는 공통 로딩 표시.
 *
 *  <LoadingDots />                        // "자료를 불러오고 있어요" + 스피너 + 점 애니메이션
 *  <LoadingDots label="검색 중입니다" />   // 커스텀 문구
 *  <LoadingDots compact />                // 패딩·크기 축소 — 좁은 영역(모달, 인라인)에 사용
 *  <LoadingDots sx={{ py: 2 }} />         // 추가 sx 병합
 */
export default function LoadingDots({
    label = "자료를 불러오고 있어요",
    compact = false,
    sx = {},
}) {
    const [dots, setDots] = useState(".");

    useEffect(() => {
        const id = setInterval(() => {
            setDots(d => (d.length >= 3 ? "." : d + "."));
        }, 400);
        return () => clearInterval(id);
    }, []);

    return (
        <Box
            sx={{
                py: compact ? 2 : 4,
                px: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.2,
                color: "#94a3b8",
                ...sx,
            }}
        >
            <CircularProgress
                size={compact ? 16 : 20}
                thickness={4.5}
                sx={{ color: "inherit" }}
            />
            <Typography
                sx={{
                    fontSize: compact ? 12 : 13,
                    fontWeight: 500,
                    color: "inherit",
                    minWidth: 0,
                    fontVariantNumeric: "tabular-nums",
                }}
            >
                {label}
                <Box component="span" sx={{ display: "inline-block", width: "1.5em", textAlign: "left" }}>
                    {dots}
                </Box>
            </Typography>
        </Box>
    );
}
